export var ICONS = {
  COINS: require("../../../assets/".concat("hri", "/images/Coin_Icon.png")),
  LOYALTY: require("../../../assets/".concat("hri", "/images/Top_Bar_Assets/Loyalty_Star_Icon.png"))
};